import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import classNames from 'classnames';
import TableRowControls from './TableRowControls';

function TableRow(_ref) {
  var children = _ref.children,
      editor = _ref.editor,
      isSelected = _ref.isSelected,
      isFirstInSelection = _ref.isFirstInSelection,
      isLastInSelection = _ref.isLastInSelection,
      props = _objectWithoutProperties(_ref, ["children", "editor", "isSelected", "isFirstInSelection", "isLastInSelection"]);

  return React.createElement("tr", {
    className: classNames('slite-editor-table-row', {
      selected: isSelected,
      'first-in-selection': isFirstInSelection,
      'last-in-selection': isLastInSelection
    })
  }, !editor.readOnly && React.createElement(TableRowControls, Object.assign({
    editor: editor
  }, props)), children);
}

export default React.memo(TableRow);